/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const STORAGE_KEY = 'buy_now_checkout';
const EXPIRATION_MS = 24 * 60 * 60 * 1000;
const DEFAULT_SOURCE = 'buy_now_modal';

export interface BuyNowMarker {
    is_buy_now: true;
    source: string;
    checkout_id?: string;
    timestamp: number;
}

export function setBuyNowCheckoutMarker({
    source = DEFAULT_SOURCE,
    checkoutId,
}: { source?: string; checkoutId?: string } = {}): void {
    try {
        const marker: BuyNowMarker = {
            is_buy_now: true,
            source,
            ...(checkoutId && { checkout_id: checkoutId }),
            timestamp: Date.now(),
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(marker));
    } catch {
        // ignore
    }
}

export function getBuyNowCheckoutMarker(): BuyNowMarker | null {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as BuyNowMarker;
        if (!parsed?.timestamp || Date.now() - parsed.timestamp > EXPIRATION_MS) {
            clearBuyNowCheckoutMarker();
            return null;
        }
        return parsed;
    } catch {
        clearBuyNowCheckoutMarker();
        return null;
    }
}

export function clearBuyNowCheckoutMarker(): void {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}
